import {fetchReadings, fetchServicePointDetails, fetchServicePoints, postServicePointAlias} from "./api";

export const SP_CLEAR = "SP_CLEAR"

export const UPDATE_SERVICE_POINTS = "UPDATE_SERVICE_POINTS"
export const SERVICE_POINTS_LOADING = "SERVICE_POINTS_LOADING"
export const SERVICE_POINTS_LOAD_ERROR = "SERVICE_POINTS_LOAD_ERROR"

export const UPDATE_DEVICES = "UPDATE_DEVICES"
export const DEVICES_LOADING = "DEVICES_LOADING"
export const FAILED_TO_LOAD_DEVICES = "FAILED_TO_LOAD_DEVICES"

export const READINGS_LOADING = "READINGS_LOADING"
export const UPDATE_READINGS = "UPDATE_READINGS"
export const FAILED_TO_LOAD_READINGS = "FAILED_TO_LOAD_READINGS"

export const SP_ALIAS_UPDATE_STARTED = "SP_ALIAS_UPDATE_STARTED"
export const SP_ALIAS_UPDATED = "SP_ALIAS_UPDATED"
export const SP_ALIAS_UPDATE_ERROR = "SP_ALIAS_UPDATE_ERROR"

export function requestServicePoints() {
    return function (dispatch, getState) {
        const token = getState().user.token;
        if (!token) {
            return Promise.reject()
        }

        dispatch(servicePointsLoading())

        fetchServicePoints(token)
            .then(response => {
                if (!response.ok) {
                    throw new Error("Response is not OK")
                }
                return response
            })
            .then(response => response.json())
            .then(spList => dispatch(updateServicePoints(spList)))
            .catch(() => dispatch(servicePointsLoadError()))
    }
}

function updateServicePoints(spList) {
    return {
        type: UPDATE_SERVICE_POINTS,
        spList
    }
}

function servicePointsLoading() {
    return {
        type: SERVICE_POINTS_LOADING
    }
}

function servicePointsLoadError() {
    return {
        type: SERVICE_POINTS_LOAD_ERROR
    }
}

export function requestServicePointDetails(spId) {
    return function (dispatch, getState) {
        const token = getState().user.token;
        if (!token) {
            return Promise.reject()
        }

        dispatch(devicesLoading(spId))

        fetchServicePointDetails(spId, token)
            .then(response => {
                if (!response.ok) {
                    throw new Error("Response is not OK")
                }
                return response
            })
            .then(response => response.json())
            .then(dvcList => {
                dispatch(updateDevices(spId, dvcList))
            })
            .catch(() => dispatch(failedToLoadDevices(spId)))
    }
}

function updateDevices(spId, dvcList) {
    return {
        type: UPDATE_DEVICES,
        spId,
        dvcList
    }
}

function devicesLoading(spId) {
    return {
        type: DEVICES_LOADING,
        spId
    }
}

function failedToLoadDevices(spId) {
    return {
        type: FAILED_TO_LOAD_DEVICES,
        spId
    }
}

export function requestReadings(spId, dateFrom, dateTo, mcId) {
    return function (dispatch, getState) {
        const token = getState().user.token;
        if (!token) {
            return Promise.reject()
        }

        const request = {
            spId, mcId,
            startDate: dateFrom.toISOString(),
            endDate: dateTo.toISOString()
        }

        dispatch(readingsLoading(spId))

        fetchReadings(request, token)
            .then(response => {
                if (!response.ok) {
                    throw new Error("Response is not OK")
                }
                return response
            })
            .then(response => response.json())
            .then(rdgList => {
                dispatch(updateReadings(spId, rdgList))
            })
            .catch(dispatch(failedToLoadReadings()))
    }
}

function readingsLoading(spId) {
    return {
        type: READINGS_LOADING,
        spId
    }
}

function updateReadings(spId, rdgList) {
    return {
        type: UPDATE_READINGS,
        spId,
        rdgList
    }
}

function failedToLoadReadings(spId) {
    return {
        type: FAILED_TO_LOAD_READINGS,
        spId
    }
}

export function changeServicePointAlias(spId, newAlias) {
    return function(dispatch, getState) {
        const sp = getState().sp.list.find(sp => sp.id === spId)
        if (!!sp && sp.alias === newAlias) {
            dispatch(spAliasUpdated(spId, newAlias))
            return Promise.resolve()
        }

        const token = getState().user.token;
        if (!token) {
            return Promise.reject()
        }
        dispatch(spAliasUpdateStarted())

        postServicePointAlias(spId, newAlias, token)
            .then(response => {
                if (!response.ok) {
                    throw new Error("Response is not OK")
                }
                return response
            })
            .then(() => dispatch(spAliasUpdated(spId, newAlias)))
            .catch(() => dispatch(spAliasUpdateError()))
    }
}

function spAliasUpdateStarted() {
    return {
        type: SP_ALIAS_UPDATE_STARTED
    }
}

function spAliasUpdated(spId, newAlias) {
    return {
        type: SP_ALIAS_UPDATED,
            spId,
            newAlias
    }
}

function spAliasUpdateError() {
    return {
        type: SP_ALIAS_UPDATE_ERROR
    }
}

export function clearServicePoints() {
    return {
        type: SP_CLEAR
    }
}